module.exports = __webpack_public_path__ + "img/dw.a75d3961.png";